module.exports = __webpack_public_path__ + "static/media/hero-people-office.cd30cbe5.png";